const buttons_change = () => {
  const buttons = document.querySelectorAll('.main-content.original.main-content-collection .btn-add-to-cart');

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const variantId = event.currentTarget.getAttribute("data-product-id");
      const elements = document.querySelectorAll(`[id*="sizes-by-${variantId}"] > ul`);

      elements.forEach((element) => {
        element.classList.add("open-sizes");
      });

      const parentElement = button.parentElement;
      if (parentElement) {
        parentElement.style.display = 'none';
      }
    });
  });
}

const revert_buttons_change = () => {
  const buttons = document.querySelectorAll('.main-content.original.main-content-collection .btn-add-to-cart');
  buttons.forEach((button) => {
    const variantId = button.getAttribute("data-product-id");
    const elements = document.querySelectorAll(`[id*="sizes-by-${variantId}"] > ul`);

    elements.forEach((element) => {
      element.classList.remove("open-sizes");
    });

    const parentElement = button.parentElement;
    if (parentElement ) {
      if(window.innerWidth < 769){
        parentElement.style.display = 'block';
        if(parentElement.classList.contains('hover-buttons')){
          parentElement.style.display = 'none';
        }

      }else{
        parentElement.style.display = 'flex';
        if(parentElement.classList.contains('hover-buttons-mobile')){
          parentElement.style.display = 'none';
        }
      }
    }
  });
}

const redesign_plp = () => {
    buttons_change()
}

window.addEventListener('resize', () => {
  revert_buttons_change()
});

export default redesign_plp;
